var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#DDE7F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3438 19.4062C21.3438 20.5749 21.808 21.6956 22.6343 22.5219C23.4606 23.3483 24.5814 23.8125 25.75 23.8125C26.9186 23.8125 28.0394 23.3483 28.8657 22.5219C29.692 21.6956 30.1562 20.5749 30.1562 19.4062C30.1562 18.2376 29.692 17.1169 28.8657 16.2906C28.0394 15.4642 26.9186 15 25.75 15C24.5814 15 23.4606 15.4642 22.6343 16.2906C21.808 17.1169 21.3438 18.2376 21.3438 19.4062Z",
    stroke: "#0857C3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6875 32.625C28.6875 33.7936 29.1517 34.9144 29.9781 35.7407C30.8044 36.567 31.9251 37.0312 33.0938 37.0312C34.2624 37.0312 35.3831 36.567 36.2094 35.7407C37.0358 34.9144 37.5 33.7936 37.5 32.625C37.5 31.4564 37.0358 30.3356 36.2094 29.5093C35.3831 28.683 34.2624 28.2188 33.0938 28.2188C31.9251 28.2188 30.8044 28.683 29.9781 29.5093C29.1517 30.3356 28.6875 31.4564 28.6875 32.625Z",
    stroke: "#0857C3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 32.625C14 33.2036 14.114 33.7766 14.3354 34.3112C14.5568 34.8458 14.8814 35.3315 15.2906 35.7407C15.6997 36.1498 16.1855 36.4744 16.7201 36.6958C17.2546 36.9173 17.8276 37.0312 18.4062 37.0312C18.9849 37.0312 19.5579 36.9173 20.0924 36.6958C20.627 36.4744 21.1128 36.1498 21.5219 35.7407C21.9311 35.3315 22.2557 34.8458 22.4771 34.3112C22.6985 33.7766 22.8125 33.2036 22.8125 32.625C22.8125 32.0464 22.6985 31.4734 22.4771 30.9388C22.2557 30.4042 21.9311 29.9185 21.5219 29.5093C21.1128 29.1002 20.627 28.7756 20.0924 28.5542C19.5579 28.3327 18.9849 28.2188 18.4062 28.2188C17.8276 28.2188 17.2546 28.3327 16.7201 28.5542C16.1855 28.7756 15.6997 29.1002 15.2906 29.5093C14.8814 29.9185 14.5568 30.4042 14.3354 30.9388C14.114 31.4734 14 32.0464 14 32.625Z",
    stroke: "#0857C3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/Information.4c189c4f752271909c613861167eb049.svg";
export { ForwardRef as ReactComponent };